import { FleetAdminCircleData, InviteCodeData } from '../../../../@types';
import { RootState } from '../../../config';

export const selectCircles = (
  state: RootState
): FleetAdminCircleData[] | null => state.userData?.circles?.entities;

export const selectDisplayCircles = (
  state: RootState
): FleetAdminCircleData[] | null => state.userData?.circles?.display;

export const selectSelectedCircle = (
  state: RootState
): FleetAdminCircleData | null => state.userData?.circles?.selected;

export const selectFetchedCircles = (state: RootState) =>
  state.userData?.circles?.fetchedCircles;

export const selectLoadingCircle = (state: RootState) =>
  state.userData?.circles?.loadingCircle;

export const selectCirclesLoading = (state: RootState): boolean =>
  state.userData.circles.loading;

export const selectIsInitialCirclesLoad = (state: RootState): boolean =>
  state.userData.circles.loading && !state.userData.circles.entities?.length;

export const selectInviteCodes = (state: RootState): InviteCodeData[] | null =>
  state.userData?.circles?.inviteCodes;

export const selectFetchingInviteCodes = (state: RootState): boolean =>
  state.userData?.circles?.fetchingInviteCodes;

export const selectSelectedInviteCode = (
  state: RootState
): InviteCodeData | null => state.userData?.circles?.selectedInviteCode;

export const selectCreatingInviteCode = (state: RootState): boolean =>
  state.userData?.circles?.creatingInviteCode;
